import { TFunction } from 'i18next'
import { nameOf } from '../../../../utils/functions/ReflectionUtil'
import { Order } from '../../../../core/models/entities/Order'

export function orderColumnsConfig(t: TFunction) {
  return [
    {
      value: nameOf<Order>(x => x.orderNumber),
      canSortBy: true,
      displayValue: t('orderListDetails.colOrderNo'),
      weight: 1
    },
    {
      value: nameOf<Order>(x => x.requisitionNumber),
      canSortBy: true,
      displayValue: t('orderListDetails.colRequisitionNumber'),
      weight: 1.5
    },
    {
      value: nameOf<Order>(x => x.organization),
      canSortBy: true,
      displayValue: t('customer'),
      weight: 2
    },
    {
      value: nameOf<Order>(x => x.organization.contactPerson),
      canSortBy: true,
      displayValue: t('orderListDetails.colContactPerson'),
      weight: 0
    },
    {
      value: nameOf<Order>(x => x.status),
      canSortBy: true,
      displayValue: t('status'),
      weight: 1.5
    },
    {
      value: nameOf<Order>(x => x.placedAtUtc),
      canSortBy: true,
      displayValue: t('orderListDetails.colOrderDate'),
      weight: 1
    },
    {
      value: nameOf<Order>(x => x.latestDelivery),
      canSortBy: true,
      displayValue: t('orderConfirmation.estShipmentDate'),
      weight: 1.4
    },
    {
      value: 'actions',
      canSortBy: false,
      displayValue: t('action'),
      weight: 1.2
    }
  ]
}
